// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminWithdrawalsRouteImport } from './routes/admin/withdrawals'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminTransactionsRouteImport } from './routes/admin/transactions'
import { Route as AdminTelegramRouteImport } from './routes/admin/telegram'
import { Route as AdminSubAdminsRouteImport } from './routes/admin/sub-admins'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminResultsRouteImport } from './routes/admin/results'
import { Route as AdminReportsRouteImport } from './routes/admin/reports'
import { Route as AdminQueueRouteImport } from './routes/admin/queue'
import { Route as AdminNotificationsRouteImport } from './routes/admin/notifications'
import { Route as AdminNoticesRouteImport } from './routes/admin/notices'
import { Route as AdminGamesRouteImport } from './routes/admin/games'
import { Route as AdminErrorsRouteImport } from './routes/admin/errors'
import { Route as AdminDiagnosticsRouteImport } from './routes/admin/diagnostics'
import { Route as AdminDepositsRouteImport } from './routes/admin/deposits'
import { Route as AdminBetsRouteImport } from './routes/admin/bets'
import { Route as AdminBannersRouteImport } from './routes/admin/banners'
import { Route as AdminBackupsRouteImport } from './routes/admin/backups'
import { Route as AdminAutomaticPaymentsRouteImport } from './routes/admin/automatic-payments'
import { Route as AdminAuditRouteImport } from './routes/admin/audit'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedWalletRouteImport } from './routes/_authenticated/wallet'
import { Route as AuthenticatedResultsRouteImport } from './routes/_authenticated/results'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedMatchesRouteImport } from './routes/_authenticated/matches'
import { Route as AuthenticatedHistoryRouteImport } from './routes/_authenticated/history'
import { Route as AuthenticatedHelpRouteImport } from './routes/_authenticated/help'
import { Route as AuthenticatedBetsRouteImport } from './routes/_authenticated/bets'
import { Route as AuthenticatedPlayGameIdRouteImport } from './routes/_authenticated/play.$gameId'
import { Route as AuthenticatedPaymentReturnRouteImport } from './routes/_authenticated/payment.return'

const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AdminRouteRoute = AdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRouteRoute
          })
const AdminWithdrawalsRoute = AdminWithdrawalsRouteImport.update({
            id: '/withdrawals',path: '/withdrawals',getParentRoute: () => AdminRouteRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRouteRoute
          })
const AdminTransactionsRoute = AdminTransactionsRouteImport.update({
            id: '/transactions',path: '/transactions',getParentRoute: () => AdminRouteRoute
          })
const AdminTelegramRoute = AdminTelegramRouteImport.update({
            id: '/telegram',path: '/telegram',getParentRoute: () => AdminRouteRoute
          })
const AdminSubAdminsRoute = AdminSubAdminsRouteImport.update({
            id: '/sub-admins',path: '/sub-admins',getParentRoute: () => AdminRouteRoute
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AdminRouteRoute
          })
const AdminResultsRoute = AdminResultsRouteImport.update({
            id: '/results',path: '/results',getParentRoute: () => AdminRouteRoute
          })
const AdminReportsRoute = AdminReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AdminRouteRoute
          })
const AdminQueueRoute = AdminQueueRouteImport.update({
            id: '/queue',path: '/queue',getParentRoute: () => AdminRouteRoute
          })
const AdminNotificationsRoute = AdminNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AdminRouteRoute
          })
const AdminNoticesRoute = AdminNoticesRouteImport.update({
            id: '/notices',path: '/notices',getParentRoute: () => AdminRouteRoute
          })
const AdminGamesRoute = AdminGamesRouteImport.update({
            id: '/games',path: '/games',getParentRoute: () => AdminRouteRoute
          })
const AdminErrorsRoute = AdminErrorsRouteImport.update({
            id: '/errors',path: '/errors',getParentRoute: () => AdminRouteRoute
          })
const AdminDiagnosticsRoute = AdminDiagnosticsRouteImport.update({
            id: '/diagnostics',path: '/diagnostics',getParentRoute: () => AdminRouteRoute
          })
const AdminDepositsRoute = AdminDepositsRouteImport.update({
            id: '/deposits',path: '/deposits',getParentRoute: () => AdminRouteRoute
          })
const AdminBetsRoute = AdminBetsRouteImport.update({
            id: '/bets',path: '/bets',getParentRoute: () => AdminRouteRoute
          })
const AdminBannersRoute = AdminBannersRouteImport.update({
            id: '/banners',path: '/banners',getParentRoute: () => AdminRouteRoute
          })
const AdminBackupsRoute = AdminBackupsRouteImport.update({
            id: '/backups',path: '/backups',getParentRoute: () => AdminRouteRoute
          })
const AdminAutomaticPaymentsRoute = AdminAutomaticPaymentsRouteImport.update({
            id: '/automatic-payments',path: '/automatic-payments',getParentRoute: () => AdminRouteRoute
          })
const AdminAuditRoute = AdminAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => AdminRouteRoute
          })
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedWalletRoute = AuthenticatedWalletRouteImport.update({
            id: '/wallet',path: '/wallet',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedResultsRoute = AuthenticatedResultsRouteImport.update({
            id: '/results',path: '/results',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMatchesRoute = AuthenticatedMatchesRouteImport.update({
            id: '/matches',path: '/matches',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedHistoryRoute = AuthenticatedHistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedHelpRoute = AuthenticatedHelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedBetsRoute = AuthenticatedBetsRouteImport.update({
            id: '/bets',path: '/bets',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPlayGameIdRoute = AuthenticatedPlayGameIdRouteImport.update({
            id: '/play/$gameId',path: '/play/$gameId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPaymentReturnRoute = AuthenticatedPaymentReturnRouteImport.update({
            id: '/payment/return',path: '/payment/return',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedBetsRoute: AuthenticatedBetsRoute,AuthenticatedHelpRoute: AuthenticatedHelpRoute,AuthenticatedHistoryRoute: AuthenticatedHistoryRoute,AuthenticatedMatchesRoute: AuthenticatedMatchesRoute,AuthenticatedProfileRoute: AuthenticatedProfileRoute,AuthenticatedResultsRoute: AuthenticatedResultsRoute,AuthenticatedWalletRoute: AuthenticatedWalletRoute,AuthenticatedIndexRoute: AuthenticatedIndexRoute,AuthenticatedPaymentReturnRoute: AuthenticatedPaymentReturnRoute,AuthenticatedPlayGameIdRoute: AuthenticatedPlayGameIdRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const AdminRouteRouteChildren = {
  AdminAuditRoute: AdminAuditRoute,AdminAutomaticPaymentsRoute: AdminAutomaticPaymentsRoute,AdminBackupsRoute: AdminBackupsRoute,AdminBannersRoute: AdminBannersRoute,AdminBetsRoute: AdminBetsRoute,AdminDepositsRoute: AdminDepositsRoute,AdminDiagnosticsRoute: AdminDiagnosticsRoute,AdminErrorsRoute: AdminErrorsRoute,AdminGamesRoute: AdminGamesRoute,AdminNoticesRoute: AdminNoticesRoute,AdminNotificationsRoute: AdminNotificationsRoute,AdminQueueRoute: AdminQueueRoute,AdminReportsRoute: AdminReportsRoute,AdminResultsRoute: AdminResultsRoute,AdminSettingsRoute: AdminSettingsRoute,AdminSubAdminsRoute: AdminSubAdminsRoute,AdminTelegramRoute: AdminTelegramRoute,AdminTransactionsRoute: AdminTransactionsRoute,AdminUsersRoute: AdminUsersRoute,AdminWithdrawalsRoute: AdminWithdrawalsRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(AdminRouteRouteChildren)

const rootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AdminRouteRoute: AdminRouteRouteWithChildren,AuthRoute: AuthRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)